<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
              v-model="item.titre"
              :error-messages="titreErrors"
              :label="$t('orderaction.titre')"
              required
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
              v-if="typeSelectItems"
              v-model="item.type"
              :items="typeSelectItems"
              :error-messages="typeErrors"
              :no-data-text="$t('global.no_result')"
              :placeholder="$t('global.no_select')"
              clearable
              :label="$t('orderaction.type')"
              item-text="name"
              item-value="@id"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <template>
            <v-file-input v-model="item.file" :error-messages="fileErrors" :label="$t('global.fileinput')">
              <template v-slot:selection="{ text, index }">
                <v-chip v-if="index < 2" color="primary" dark label small>
                  {{ text }} - {{ convertToMo(item.file.size) }} Mo
                </v-chip>
                <span v-else-if="index === 2">
                  +{{ item.file.length - 2 }}
                </span>
              </template>
            </v-file-input>
        </template>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-textarea
              v-model="item.comment"
              :error-messages="commentErrors"
              :label="$t('orderaction.content')"
              auto-grow
              rows="1"
              row-height="15"
          />
        </v-col>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import { maxsizefile } from '../../utils/files';
import userHasAccess from '../../mixins/AccessMixin';

export default {
  name: 'OrderForm',
  mixins: [userHasAccess,validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },
defaultvalues: {
      type: Object,
      required: false
    },
    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    },
  },

  mounted() {
    this.typeGetSelectItems();
  },

  data() {
    return {
      titre: null,
      type: null,
      file: null,
      comment:null,
      search: null,
    };
  },

  computed: {
    isLoading() {
      return (this.isLoading_type);
    },
    ...mapFields('actiontype', {
      typeSelectItems: 'selectItems',
      isLoading_type : 'isLoading'
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    titreErrors() {
      const errors = [];

      if (!this.$v.item.titre.$dirty) return errors;

      has(this.violations, 'titre') && errors.push(this.violations.titre);

      !this.$v.item.titre.required && errors.push(this.$t('global.field_required'));

      return errors;
    },


    typeErrors() {
      const errors = [];

      if (!this.$v.item.type.$dirty) return errors;

      has(this.violations, 'type') && errors.push(this.violations.type);

      !this.$v.item.type.required && errors.push(this.$t('global.field_required'));

      return errors;
    },

    commentErrors() {
      const errors = [];

      if (!this.$v.item.comment.$dirty) return errors;

      has(this.violations, 'comment') && errors.push(this.violations.comment);

      !this.$v.item.comment.required && errors.push(this.$t('global.field_required'));

      return errors;
    },

    fileErrors() {
      const errors = [];

      if (!this.$v.item.file.$dirty) return errors;

      has(this.violations, 'file') && errors.push(this.violations.file);

      if(this.item.file != null && !this.$v.item.file.maxsizefile){
        if(!this.userHasAccess('unlimited_size_file')){
          errors.push(this.$t('global.sizeerror_20'));
        }
      }
      has(this.violations, 'file') && errors.push(this.violations.file);
      
      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },

  methods: {
    convertToMo(sizeInBytes) {
      return (sizeInBytes / (1024 * 1024)).toFixed(2);
    },
    ...mapActions({
      typeGetSelectItems: 'actiontype/fetchSelectItems',
    }),
  },

  validations: {
    item: {
      file: {
        maxsizefile: maxsizefile(20),
      },
      titre: {
        required,
      },
      type: {
        required,
      },
      comment: {
        required,
      },
    }
  }
};
</script>
